function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: -53,
  width: 134,
  height: 336,
  rx: 48,
  fill: "#D84576"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  y: 53,
  width: 134,
  height: 8,
  fill: "#B90C46"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 17,
  width: 134,
  height: 8,
  fill: "#B90C46"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  y: 89,
  width: 134,
  height: 8,
  fill: "#B90C46"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  y: 125,
  width: 134,
  height: 8,
  fill: "#B90C46"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  y: 161,
  width: 134,
  height: 8,
  fill: "#B90C46"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  y: 197,
  width: 134,
  height: 8,
  fill: "#B90C46"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  y: 233,
  width: 134,
  height: 8,
  fill: "#B90C46"
});

function SvgFaqBannerItem2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 283,
    viewBox: "0 0 134 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqBannerItem2);
export default __webpack_public_path__ + "static/media/faq-banner-item-2.d67a19be.svg";
export { ForwardRef as ReactComponent };